<template>
    <b-modal id="delegationModal" :hide-footer="true">
        <div id="delegationForm">
			<div class="formTitle">
				<svg-image image="iconDelegate"/>
				<h5>{{ $t("delrpc.head") }}</h5>
			</div>

            <div class="groupLabel"><label>{{ $t("delrpc.lform") }}</label></div>
            <b-form>
                <b-form-group id="" :label="$t('delrpc.fname')" label-for="" :description="$t('delrpc.fnamedesc')">
                    <b-form-input
                        id="name"
                        required
                        placeholder=""
                        >
                    </b-form-input>
				</b-form-group>
                <b-form-group id="" :label="$t('delrpc.femail')" label-for="" :description="$t('delrpc.femaildesc')">
                    <b-form-input
                        id="email"
                        type="email"
                        required
                    >
                    </b-form-input>
				</b-form-group>
                <b-form-group id="phone-group"
                        :label="$t('delrpc.fphone')"
                        label-for="phone"
                        description=""
                    >
                        <b-form-group id="phone-group" label-for="phone">
                            <VuePhoneNumberInput class="form-group" color="#ea0c0c" :border-radius="0" required default-country-code="ID"/>
                        </b-form-group>
                </b-form-group>
                <!-- <b-form-group id="idType-group" label="Representative Identity Card Type" label-for="idType">
                    <b-form-select
                        id="idType"
                        :options="idTypes"
                        required
                    ></b-form-select>
                </b-form-group>
                <b-form-group id="idFile-group" label="Representative Identity Card File" label-for="idFile">
                    <b-form-file
                        v-model="idFile"
                        placeholder="Choose a file or drop it here"
                        drop-placeholder="Drop a file here"
                        @change="handleFileUpload"
                    ></b-form-file>
                        <b-progress class="mt-2" :max="200" height="2.5rem">
                        <b-progress-bar :value="progress">
                            {{progressAction}}<strong>{{ progress/2 }}</strong>
                        </b-progress-bar>
                    </b-progress>
                    <div><label>Selected file: {{ idFile ? idFile.name : '' }}</label></div>
                </b-form-group>
                <b-form-group id="idNumber-group" label="Representative Identity Card Number" label-for="idNumber" description="as stated on the uploaded identity card">
                    <b-form-input
                        id="idNumber"
                        v-model="form.mbsdIDNumber"
                        :state="formStatus.mbsdIDNumber.state"
                        required
                    ></b-form-input>
                </b-form-group> -->
                <b-form-checkbox
                    id="acceptance"
                    name="acceptance"
                    value="accepted"
                    unchecked-value="not_accepted"
                    >
                    <div v-html="$t('delrpc.facceptance')"></div>
				</b-form-checkbox>
                <div class="clearfix">
					<b-button block type="submit" variant="primary" size="lg"><b-spinner small type="grow"></b-spinner> {{ $t("delrpc.btn") }}</b-button>
				</div>
            </b-form>
        </div>
    </b-modal>
</template>
<script>
import SvgImage from '../components/SvgImage.vue';
import VuePhoneNumberInput from 'vue-phone-number-input';
export default {
    components : {  
        VuePhoneNumberInput,
	    SvgImage,
    },
}
</script>


// WEBPACK FOOTER //
// DelegationModal.vue